import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ColorUtilitiesService {
  public static get shikensoPinkBase(): string {
    return this.getCssVariable('--shikenso-pink-base');
  }

  public static get shikensoPinkBase12(): string {
    return this.getCssVariable('--shikenso-pink-base-12');
  }

  public static get shikensoPinkBase24(): string {
    return this.getCssVariable('--shikenso-pink-base-24');
  }

  public static get shikensoPinkBase40(): string {
    return this.getCssVariable('--shikenso-pink-base-40');
  }

  public static get shikensoPurpleBase(): string {
    return this.getCssVariable('--shikenso-purple-base');
  }

  public static get shikensoPurpleBase60(): string {
    return this.getCssVariable('--shikenso-purple-base-60');
  }

  public static get shikensoGrayBase(): string {
    return this.getCssVariable('--shikenso-gray-base');
  }

  public static get shikensoGrayBase12(): string {
    return this.getCssVariable('--shikenso-gray-base-12');
  }

  public static get shikensoGrayBase24(): string {
    return this.getCssVariable('--shikenso-gray-base-24');
  }

  public static get shikensoGrayBase40(): string {
    return this.getCssVariable('--shikenso-gray-base-40');
  }

  public static get shikensoGrayBase60(): string {
    return this.getCssVariable('--shikenso-gray-base-60');
  }

  public static get shikensoGray400(): string {
    return this.getCssVariable('--shikenso-gray-400');
  }

  public static get shikensoGray40012(): string {
    return this.getCssVariable('--shikenso-gray-400-12');
  }

  public static get shikensoGray40024(): string {
    return this.getCssVariable('--shikenso-gray-400-24');
  }

  public static get shikensoGray40040(): string {
    return this.getCssVariable('--shikenso-gray-400-40');
  }

  public static get shikensoGray40060(): string {
    return this.getCssVariable('--shikenso-gray-400-60');
  }

  public static get shikensoGray600(): string {
    return this.getCssVariable('--shikenso-gray-600');
  }

  public static get shikensoGray700(): string {
    return this.getCssVariable('--shikenso-gray-700');
  }

  public static get shikensoBaseWhite(): string {
    return this.getCssVariable('--shikenso-base-white');
  }

  private static getCssVariable(variableName: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
  }
}
